var DEFAULTS = {
    mobile: 768,
    tablet: 1024,
};
export var whichDevice = function (width, config) {
    if (config === void 0) { config = DEFAULTS; }
    if (width < config.mobile) {
        return { mobile: true };
    }
    else if (width <= config.tablet) {
        return { tablet: true };
    }
    return { desktop: true };
};
//# sourceMappingURL=index.js.map